import axios from "axios";

const serverUrl = "https://www.yespu.cn";

/**
 * 通用 GET 请求
 * @param {string} url - 接口路径（不包含 baseUrl）
 * @param {Object} params - 查询参数（query string）
 * @param {Object} config - axios 配置（可选）
 * @returns {Promise<any>} 响应数据
 */
const get =  async (url, params = {}, config = {}) => {
    try {
        const response = await axios.get(`${serverUrl}${url}`, {
        params,
        ...config,
        });
        return response.data;
    } catch (error) {
        console.error("GET 请求失败:", error);
        throw error; // 重新抛出错误，便于调用方处理
    }
}
/**
 * 通用 POST 请求
 * @param {string} url - 接口路径（不包含 baseUrl）
 * @param {Object} data - 请求体数据
 * @param {Object} config - axios 配置（可选）
 * @returns {Promise<any>} 响应数据
 */
const post = async (url, data = {}, config = {}) => {
    try {
        const response = await axios.post(`${serverUrl}${url}`, data, config);
        return response.data;
    } catch (error) {
        console.error("POST 请求失败:", error);
        throw error;
    }
}

export default {
  get:get,
  post:post,
  /**
   * 增加使用次数
   */
  useCountIncr: async () => {
    return await get("/api/v1/codetool/use_count");
  },

  /**
   * 获取当前时间戳
   */
  getTimestamp: async () => {
    const res = await get("/api/v1/codetool/timestamp");
    return res; // 假设后端直接返回时间戳数字或对象
  },
};